import { useEffect, useState } from 'react';
import BlogService from '../../services/BlogService';
import { useParams } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import { Helmet } from 'react-helmet-async';

const BlogSinglePage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    BlogService.fetchOne(slug)
      .then((r) => {
        setBlog(r.data);
        setLoading(false);
      })
      .catch(() => {
        setError('Blog nije pronađen.');
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <div className='container mx-auto py-20 text-center'>Učitavanje...</div>;
  if (error) return <div className='container mx-auto py-20 text-center text-red-500'>{error}</div>;

  const blogImage = blog.images?.[0]
    ? blog.images[0].startsWith('http')
      ? blog.images[0]
      : import.meta.env.VITE_IMAGE_URL + blog.images[0]
    : undefined;

  const blogPublishedTime = blog.date ? new Date(blog.date).toISOString() : undefined;
  const blogKeywords =
    blog.seoMeta?.keywords || [blog.title, 'blog', 'rentiranje', 'Rentasvet', 'saveti za rentiranje'].filter(Boolean).join(', ');
  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: blog.seoMeta?.title || blog.title,
    description: blog.seoMeta?.description || blog.content?.replace(/<[^>]*>/g, '').slice(0, 160),
    image: blogImage ? [blogImage] : undefined,
    datePublished: blogPublishedTime,
    author: { '@type': 'Organization', name: 'Rentasvet', url: 'https://rentasvet.rs' },
    publisher: {
      '@type': 'Organization',
      name: 'Rentasvet',
      logo: { '@type': 'ImageObject', url: 'https://rentasvet.rs/src/assets/favicon.png' },
    },
    mainEntityOfPage: { '@type': 'WebPage', '@id': `https://rentasvet.rs/blog/${slug}` },
  };

  return (
    <>
      <SEO
        title={blog.seoMeta?.title || blog.title}
        description={blog.seoMeta?.description || blog.content?.replace(/<[^>]*>/g, '').slice(0, 160)}
        keywords={blogKeywords}
        image={blogImage}
        imageAlt={blog.seoMeta?.title || blog.title}
        url={`/blog/${slug}`}
        type='article'
        lang='sr'
        jsonLd={articleJsonLd}
      />
      {blogPublishedTime && (
        <Helmet>
          <meta property='article:published_time' content={blogPublishedTime} />
          <meta property='article:author' content='Rentasvet' />
          <meta property='article:section' content='Blog' />
        </Helmet>
      )}
      <div className='flex justify-center'>
        <div className='mt-12 w-full max-w-3xl rounded-lg bg-white p-4 shadow-lg md:p-10'>
          {blog.images && blog.images.length > 0 && (
            <div className='mb-8 w-full'>
              <img
                src={blog.images[0].startsWith('http') ? blog.images[0] : import.meta.env.VITE_IMAGE_URL + blog.images[0]}
                alt='blog naslovna'
                className='h-80 w-full rounded-xl object-cover shadow'
              />
            </div>
          )}
          <h1 className='mb-2 text-4xl font-extrabold'>{blog.title}</h1>
          {/*   <div className='mb-8 text-sm text-gray-500'>{new Date(blog.date).toLocaleString()}</div> */}
          <div className='prose prose-lg mb-8 max-w-none'>{blog.content}</div>
          {/* SEO meta — može se koristiti u helmet, ovde je prikaz radi provere */}
          {blog.seoMeta?.title && <div className='mt-6 text-xs italic text-gray-400'>SEO: {blog.seoMeta.title}</div>}
        </div>
      </div>
    </>
  );
};

export default BlogSinglePage;
